import { GoogleLogin } from '@react-oauth/google';
import { FC } from 'react';

import { Form, Formik } from 'formik';

import AuthWrapper from 'components/modules/AuthWrapper';
import Button from 'components/primitives/Button';

import { initialValues, validationSchema } from './Login.utils';

import images from 'assets/images';
import PasswordInput from 'components/primitives/PasswordInput';
import TextInput from 'components/primitives/TextInput';
import { LoginViewProps } from './Login.props';

const LoginView: FC<LoginViewProps> = ({
  onSubmit,
  isLoading,
  goToRegister,
  goToForgotPassword,
  hideCoverImage,
  onGoogleLogin,
  isGoogleLoading,
}) => {
  const LoginForm = () => {
    const handleGoogleSuccess = (credentialResponse: any) => {
      if (credentialResponse.credential) {
        onGoogleLogin({
          idToken: credentialResponse.credential,
        });
      }
    };

    const handleCustomGoogleClick = () => {
      // Find the hidden Google button and click it
      const hiddenGoogleButton = document.querySelector(
        '#hidden-google-login div[role="button"]',
      ) as HTMLElement;
      if (hiddenGoogleButton) {
        hiddenGoogleButton.click();
      }
    };

    return (
      <div>
        <h2 className="text-center">Log in to your account</h2>
        <p className="font-secondary text-center mt-1">
          Welcome back to Rapid Rentals!
        </p>
        <div className="justify-center items-center place-items-center m-4">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={validationSchema}>
            <Form className="flex flex-col justify-center w-full">
              <TextInput name="username" placeholder="Email" />
              <PasswordInput name="password" placeholder="Password" />
              <div className="flex justify-end mb-2">
                <p
                  onClick={goToForgotPassword}
                  className="text-sm text-primary-500 cursor-pointer">
                  Forgot Password?
                </p>
              </div>
              <Button
                isLoading={isLoading}
                id="open-btn"
                type="submit"
                variant="solid"
                colorScheme="primary"
                className="w-full mt-3">
                Login
              </Button>
            </Form>
          </Formik>
        </div>

        <div className="flex flex-row justify-center mt-5 text-gray-600 mx-4">
          <p className="text-sm">Don´t have an account?&nbsp;</p>
          <p
            onClick={goToRegister}
            className="text-sm text-primary-500 cursor-pointer">
            Sign up
          </p>
        </div>

        <div className="divider text-sm mx-4">OR</div>

        {/* Hidden Google Login Component */}
        <div
          id="hidden-google-login"
          className="hidden absolute left-[-9999px]">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            useOneTap={false}
            auto_select={false}
          />
        </div>

        <div className="flex gap-4 justify-stretch mb-4">
          <Button
            isLoading={isGoogleLoading}
            variant="outline"
            colorScheme="gray"
            type="button"
            onClick={handleCustomGoogleClick}
            className="btn mx-4 flex-1 border-1 border-[#999999] !text-[#333]">
            <img src={images.googleLogo} width={22} alt="Google Logo" /> Login
            with Google
          </Button>
          {/* <button
            type="button"
            className="btn flex-1 border-1 border-[#999999] bg-transparent hover:bg-[#f0f0f0] text-[#333] hover:text-black"
            title="Sign in with Microsoft (Coming Soon)"
            disabled>
            <img src={images.microsoftLogo} width={22} alt="Microsoft Logo" />
          </button>
          <button
            type="button"
            className="btn flex-1 border-1 border-[#999999] bg-transparent hover:bg-[#f0f0f0] text-[#333] hover:text-black"
            title="Sign in with Apple (Coming Soon)"
            disabled>
            <img src={images.appleLogo} width={22} alt="Apple Logo" />
          </button> */}
        </div>

        {/* Removed Continue as Guest button per product requirement */}
      </div>
    );
  };
  return hideCoverImage ? (
    <LoginForm />
  ) : (
    <AuthWrapper>
      <LoginForm />
    </AuthWrapper>
  );
};

export default LoginView;
